import type { FormInstance } from "antd";
import { Form, Input, Select } from "antd";
import { useEffect } from "react";
import { useEquipmentList } from "@/modules/equipment/hooks/useEquipment";
import { useGpsDevicesStore } from "../store/gps-devices.store";

const STATUS_OPTIONS: { value: string; label: string }[] = [
	{ value: "online", label: "Online" },
	{ value: "offline", label: "Offline" },
	{ value: "error", label: "Xato" },
];

interface GpsDeviceFormProps {
	form?: FormInstance;
	organizationId: string;
}

export function GpsDeviceForm({ form, organizationId }: GpsDeviceFormProps) {
	const editingDevice = useGpsDevicesStore((s) => s.editingDevice);
	const { data: equipmentData } = useEquipmentList({
		organizationId,
		limit: 100,
	});
	const equipmentList = equipmentData?.data?.items ?? [];

	// Set values when editing or creating
	useEffect(() => {
		if (editingDevice) {
			form?.setFieldsValue({
				imei: editingDevice.imei,
				equipmentId: editingDevice.equipmentId,
				status: editingDevice.status,
				organizationId: editingDevice.organizationId,
			});
		} else {
			form?.resetFields();
			form?.setFieldsValue({ organizationId, status: "offline" });
		}
	}, [editingDevice, form, organizationId]);

	return (
		<Form form={form} layout="vertical" requiredMark={false}>
			<Form.Item name="organizationId" hidden>
				<Input type="hidden" />
			</Form.Item>
			<Form.Item
				name="imei"
				label="IMEI"
				rules={[
					{ required: true, message: "IMEI kiriting" },
					{ max: 64, message: "Maksimum 64 ta belgi" },
				]}
			>
				<Input placeholder="Masalan: 123456789012345" size="middle" />
			</Form.Item>
			<Form.Item name="equipmentId" label="Texnika">
				<Select
					placeholder="Texnikani tanlang (ixtiyoriy)"
					allowClear
					showSearch
					filterOption={(input, option) =>
						(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
					}
					options={equipmentList.map((e) => ({
						value: e.id,
						label: `${e.name} (${e.serialNumber})`,
					}))}
				/>
			</Form.Item>
			<Form.Item name="status" label="Holati">
				<Select options={STATUS_OPTIONS} placeholder="Holatni tanlang" allowClear />
			</Form.Item>
		</Form>
	);
}
